
const getListRecord = state => state.list

export default {
  getListRecord
}



// WEBPACK FOOTER //
// ./src/store/modules/medical-record/getters.js